import { ThemeProvider } from '@primer/react';
import { AuthProvider } from 'oidc-react';
import { useEffect, useMemo } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import BaseStyles from './BaseStyles';
import LoaderPage from './components/loader-page';
import AuthorizedContent from './content/AuthorizedContent';
import SigoutContent from './content/SigoutContent';
import UnAuthorizedContent from './content/UnAuthorizedContent';
import { CommonProvider } from './contexts/common';
import { actions } from './state/actions/actionsWrapper';
import { localizedResourceAction } from './state/actions/localized-resource/localizedResourceAction';
import { RootState } from './state/reducers';
import { eAccountReducerStatus } from './state/reducers/authReducer';
import LegalViewPage from './pages/legal-document/view';

function App() {
  const { user_info, status, isSignOuted } = useSelector((x: RootState) => x.auth)
  const { language } = useSelector((x: RootState) => x.common)
  const { appConfig } = useSelector((x: RootState) => x.appConfig)
  const path = window.location.pathname;

  const regex = /[?&]lan=([^&]+)/;
  const match = window.location.search.match(regex);
  const languageParam = match ? match[1] : "vi"
  console.log({
    path,
    languageParam
  });


  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(localizedResourceAction.loadStart(language))
  }, [language])
  useEffect(() => {
    dispatch(actions.appConfig.loadStart())
  }, [])
  const oidcConfig: any = useMemo(() => {
    if (!appConfig) {
      // debugger
    }
    return {
      onSignIn: (e: any) => {
        // debugger
        console.log({
          onSignIn: e
        });
      },
      authority: appConfig?.OIDC_AUTHORITY,
      clientId: appConfig?.OIDC_CLIENT_ID,
      redirectUri: appConfig?.OIDC_REDIRECT_URI,
      clientSecret: appConfig?.OIDC_CLIENT_SECRET,

    };
  }, [appConfig])
  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      dispatch(actions.account.getUserStart())
    }
  }, [])

  if (status === eAccountReducerStatus.is_getting_profile) {
    return <LoaderPage />
  }
  // if (appConfigStatus === ePageBaseStatus.is_loading) {
  //   return <LoaderPage />
  // }
  // if (path === "/legal") {
  //   return <LegalViewPage />
  // }

  return (
    <Router>
      <ThemeProvider colorMode={"light"}>
        <BaseStyles>
          <CommonProvider>
            {path === "/legal" &&
              <LegalViewPage isShowPhoneFrame={false} lan={languageParam} />
            }
            {path !== "/legal" &&
              <>
                {isSignOuted === true &&
                  <AuthProvider {...oidcConfig} >
                    <SigoutContent />
                  </AuthProvider>
                }

                {user_info && <AuthorizedContent />}
                {!user_info && <UnAuthorizedContent />}
              </>}

          </CommonProvider>
        </BaseStyles>
      </ThemeProvider>
    </Router>
  );
}

export default App;
